import type { Dispatch, SetStateAction } from 'react';
import React from 'react';
import { cn } from '@savvy-kit/lib/utils';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

function PortfolioBox({
  containerRef,
  children,
  backgroundClassName,
}: {
  readonly containerRef?: Dispatch<SetStateAction<HTMLElement | undefined>>;
  readonly children: React.ReactNode;
  readonly backgroundClassName?: string;
}) {
  const isSmallScreen = useIsSmallScreen();
  return (
    <div
      ref={(node) => {
        containerRef?.(node ?? undefined);
      }}
      className={cn(
        isSmallScreen ? 'pt-6' : ['mt-4 rounded-lg border border-border-light p-8 shadow-lg', backgroundClassName],
      )}
    >
      {children}
    </div>
  );
}

export default PortfolioBox;
